export default "__VITE_ASSET__BCAA2UEi__"